// extracted by mini-css-extract-plugin
module.exports = {"container":"printer-viewer_container__3iup2"};